<template>
  <Base>
  <template v-slot:toolbar>
    <div class="toolbar" id="kt_toolbar">
      <div class="container-fluid d-flex flex-stack" id="kt_toolbar_container">
        <div class="d-flex align-items-center me-3">
          <slot name="leftToolbar">
            <span class="h-20px border-gray-200 border-start mx-4"></span>
            <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
              <li class="breadcrumb-item text-muted">
                <router-link :to="{ name: 'dashboard' }" class="text-muted text-hover-primary">
                  <i class="fad fa-home"></i>
                  {{ trans('Gestion des Vouchers') }}
                </router-link>
              </li>
            </ul>
          </slot>
        </div>


        <div class="d-flex align-items-center py-1">
          <div class="btn-sm btn btn-primary ms-5" v-b-modal.generateModal>
            <i class="fad fa-plus"></i>
            {{ trans('Generer des coupons') }}
          </div>



        </div>

      </div>
    </div>
  </template>
  <template v-slot:content>

    <div class="card">
      <div class="card-body p-0">
        <table class="table table-striped gy-7 gs-7">
          <thead>
            <tr class="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <th>{{ trans('Coupon') }}</th>
              <th>{{ trans('Groupe de coupon') }}</th>
              <th>{{ trans('Periode de validité') }}</th>
              <th>{{ trans("Nombre d'utilisation") }}</th>
              <th>{{ trans("Nombre d'utilisation par utilisateur") }}</th>
              <th>{{ trans("Actions") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="index" v-for="(voucher, index) in vouchers">
              <td>{{ voucher.code }}</td>
              <td>
                <div class="text-primary text-decoration-underline fw-bolder">
                  {{ voucher.voucherGroup.name }}
                </div>
              </td>
              <td>{{ helper.readable(voucher.startDate, 'dmY') }} - {{ helper.readable(voucher.endDate, 'dmY') }}</td>

              <td> <span class="badge bg-primary fw-bold fs-5">{{ voucher.avenants.length }} / {{ voucher.maxUse
              }}</span>
              </td>

              <td> {{ voucher.maxUseByCustomer ?? 0 }}</td>
              <td>
                <div class="btn-group">
                  <button type="button" class="btn btn-sm btn-icon btn-light btn-active-light-primary"
                    @click="voucherEdit = voucher" v-b-modal="'editVoucherModal' + voucher.id">
                    <i class="fad fa-edit"></i>
                  </button>


                  <b-modal :title="trans('Modifier un coupons')" size="lg" centered
                    :id="'editVoucherModal' + voucher.id" :ref="'editVoucherModal' + voucher.id">
                    <form>



                      <!-- <div class="col-auto m-2 flex-grow-1">
                        <label :for="'name'" class="required form-label">{{ trans("Nom du coupon") }}</label>
                        <b-form-input :id="'name'" type="text" :state="!helper.empty(params.name)" v-model="params.name">
                        </b-form-input>
                      </div> -->

                      <div class="col-auto m-2 flex-grow-1">
                        <label :for="'code'" class="required form-label">{{ trans("Code du coupon") }}</label>
                        <b-form-input :id="'lacodebel'" type="text" :state="!helper.empty(voucherEdit.code)"
                          v-model="voucherEdit.code">
                        </b-form-input>
                      </div>

                      <!-- <div class="col-auto m-2 flex-grow-1">
                        <label :for="'count'" class="required form-label">{{ trans("Nombre du coupon") }}</label>
                        <b-form-input :id="'count'" type="number" :state="!helper.empty(params.name)" v-model="params.count">
                        </b-form-input>
                      </div> -->

                      <div class="col-auto m-2 flex-grow-1">
                        <label :for="'startDate'" class="required form-label">{{ trans('Periode de validité') }}
                        </label>
                        <div class="row">
                          <div class="col">
                            <b-form-input :id="'startDate'" type="date" :state="!helper.empty(editStartDate)"
                              v-model="editStartDate"></b-form-input>
                          </div>
                          <div class="col">
                            <b-form-input :id="'endDate'" type="date" :state="!helper.empty(editEndDate)"
                              v-model="editEndDate"></b-form-input>
                          </div>
                        </div>
                      </div>


                      <div class="col-auto m-2 flex-grow-1">
                        <label :for="'reducSelected'" class="required form-label">{{ trans("Reduction par :") }}</label>

                        <div class="input-group mb-3">


                          <select :id="'reducSelected'" class=" form-select ">
                            <option value="null">Choisir </option>
                            <option value="percent">Pourcentage </option>
                            <option value="amount">Montant </option>
                          </select>


                          <input v-if="reducSelected == 'percent' || voucherEdit.value" class="form-control"
                            :id="'percent'" type="number" placeholder="%" :state="!helper.empty(voucherEdit.value)"
                            v-model="voucherEdit.value">


                          <input :id="'mount'" v-if="reducSelected == 'amount' || voucherEdit.value"
                            class="form-control" type="number" :state="!helper.empty(voucherEdit.value)"
                            v-model="voucherEdit.value">

                        </div>
                        <div class="row">

                          <div class="col-6 m-2 ">
                            <label :for="'label'" class="required form-label">{{ trans("Nombre max d'utilisation")
                              }}</label>
                            <b-form-input :id="'label'" type="number" :state="!helper.empty(voucherEdit.maxUse)"
                              v-model="voucherEdit.maxUse">
                            </b-form-input>
                          </div>
                          <div class="col m-2 ">
                            <label :for="'label'" class="required form-label">{{ trans("Nombre max d'utilisation par
                              numero de telephone") }}</label>
                            <b-form-input :id="'label'" type="number"
                              :state="!helper.empty(voucherEdit.maxUseByCustomer)"
                              v-model="voucherEdit.maxUseByCustomer">
                            </b-form-input>
                          </div>

                        </div>

                        <div class="col-4 m-2 flex-grow-1">
                          <label :for="'label'" class="required form-label">{{ trans("Prime a atteindre") }}</label>
                          <b-form-select class="form-control form-select" v-model="voucherEdit.methodAffect">
                            <b-form-select-option :value="null">{{ trans('Selectionnez une methode de calcul') }}
                            </b-form-select-option>
                            <b-form-select-option :key="'method_' + key" :value="method"
                              v-for="(method, key) in methods">
                              {{ trans(method.label) }}
                            </b-form-select-option>
                          </b-form-select>
                        </div>
                        <div class="col-12 m-2 flex-grow-1">
                          <label :for="'label'" class="form-label">{{ trans("Branches concernées") }}</label>


                          <div>
                            <template v-for="(category, catIndex) in branchCategories">
                              <div v-for="(branch, branchIndex) in category.branches"
                                :key="'edit_branch_' + catIndex + '_' + branchIndex"
                                class="form-check form-check-inline me-3 mb-2">
                                <input class="form-check-input" v-model="voucherEdit.branchs" type="checkbox"
                                  :id="'edit_' + branch.slug" :value="branch.slug">
                                <label class="form-check-label" :for="'edit_' + branch.slug"> {{ category.label }} - {{
                                  trans(branch.label)
                                  }}</label>
                              </div>
                            </template>
                          </div>




                        </div>
                        <div class="col-12 m-2 flex-grow-1">
                          <label :for="'label'" class="required form-label">{{ trans("Assureur concerné") }}</label>


                          <div>
                            <div v-for="(insurer, insurerIndex) in insurers" :key="'edit_insurer_' + insurerIndex"
                              class="form-check form-check-inline">
                              <input class="form-check-input" v-model="voucherEdit.insurers" type="checkbox"
                                :id="'edit_' + insurer.slug" :value="insurer.slug">
                              <label class="form-check-label" :for="'edit_' + insurer.slug"> {{ trans(insurer.label)
                                }}</label>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="col-12 m-2 flex-grow-1">
                          <label :for="'label'" class="required form-label">{{ trans("Pack concerné") }}</label>


                          <div>
                            <template v-for="(packCategory, pcIndex) in packCategories">
                              <div v-for="(pack, packIndex) in packCategory.packs"
                                :key="'edit_pack_' + pcIndex + '_' + packIndex" class="form-check form-check-inline">
                                <input class="form-check-input" v-model="voucherEdit.packs" type="checkbox"
                                  :id="'edit_' + pack.code" :value="pack.code">
                                <label class="form-check-label" :for="'edit_' + pack.code"> {{ packCategory.label }} -
                                  {{
                                    trans(pack.label)
                                  }}</label>
                              </div>
                            </template>
                          </div>
                        </div> -->
                        <!-- <div class="col-auto m-2 flex-grow-1">
                        <label class="form-label">{{ trans('Description') }}</label>
                        <div>
                          <textarea class="form-control" v-model="voucherEdit.description"></textarea>
                        </div>
                      </div> -->
                      </div>
                    </form>
                    <template #modal-footer="{ cancel, hide }">
                      <b-button @click="cancel()" size="sm" variant="secondary">
                        <i class="fad fa-times"></i>
                        {{ trans('Cancel') }}
                      </b-button>
                      <b-button @click="editVoucher(), hide()" size="sm" variant="primary">
                        <i class="fad fa-save"></i>
                        {{ trans('Generer') }}
                      </b-button>
                    </template>
                  </b-modal>











                  <button type="button" class="btn btn-sm btn-icon btn-danger btn-active-danger-primary "
                    v-b-modal.dataTypeModal>
                    <i class="fad fa-trash"></i>
                  </button>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
        <div>

        </div>
      </div>
    </div>

    <b-modal :title="voucherEdit ? trans('Modifier un coupons') : trans('Generer des coupons')" size="lg" centered
      id="generateModal" ref="generateModal">
      <form>
        <div class="row" v-if="params">



          <div class="col-auto m-2 flex-grow-1">
            <label :for="'name'" class="required form-label">{{ trans("Nom du coupon") }}</label>
            <b-form-input :id="'name'" type="text" :state="!helper.empty(params.name)" v-model="params.name">
            </b-form-input>
          </div>

          <div v-if="voucherEdit != null" class="col-auto m-2 flex-grow-1">
            <label :for="'code'" class="required form-label">{{ trans("Code du coupon") }}</label>
            <b-form-input :id="'lacodebel'" type="text" :state="!helper.empty(params.code)" v-model="params.code">
            </b-form-input>
          </div>

          <div class="col-auto m-2 flex-grow-1">
            <label :for="'count'" class="required form-label">{{ trans("Nombre du coupon") }}</label>
            <b-form-input :id="'count'" type="number" :state="!helper.empty(params.name)" v-model="params.count">
            </b-form-input>
          </div>

          <div class="col-auto m-2 flex-grow-1">
            <label :for="'startDate'" class="required form-label">{{ trans('Periode de validité') }}</label>
            <div class="row">
              <div class="col">
                <b-form-input :id="'startDate'" type="date" :state="!helper.empty(params.startDate)"
                  v-model="params.startDate"></b-form-input>
              </div>
              <div class="col">
                <b-form-input :id="'endDate'" type="date" :state="!helper.empty(params.endDate)"
                  v-model="params.endDate"></b-form-input>
              </div>
            </div>
          </div>


          <div class="col-auto m-2 flex-grow-1">
            <label :for="'reducSelected'" class="required form-label">{{ trans("Reduction par :") }}</label>

            <div class="input-group mb-3">


              <select :id="'reducSelected'" v-model="reducSelected" class=" form-select ">
                <option value="null">Choisir </option>
                <option value="percent">Pourcentage </option>
                <option value="amount">Montant </option>
              </select>


              <input v-if="reducSelected == 'percent'" class="form-control" :id="'percent'" type="number"
                placeholder="%" :state="!helper.empty(params.value)" v-model="params.value">


              <input :id="'mount'" v-if="reducSelected == 'amount'" class="form-control" type="number"
                :state="!helper.empty(params.value)" v-model="params.value">

            </div>

          </div>



          <div class="col-4 m-2 flex-grow-1">
            <label :for="'label'" class="required form-label">{{ trans("Nombre max d'utilisation") }}</label>
            <b-form-input :id="'label'" type="number" :state="!helper.empty(params.maxUse)" v-model="params.maxUse">
            </b-form-input>
          </div>

          <div class="col-4 m-2 flex-grow-1">
            <label :for="'label'" class="required form-label">{{ trans("Nombre max d'utilisation par numero de
              telephone")
            }}</label>
            <b-form-input :id="'label'" type="number" :state="!helper.empty(params.maxUseByCustomer)"
              v-model="params.maxUseByCustomer">
            </b-form-input>
          </div>

          <div class="col-4 m-2 flex-grow-1">
            <label :for="'label'" class="required form-label">{{ trans("Prime a atteindre") }}</label>
            <b-form-select class="form-control form-select" v-model="params.methodAffect">
              <b-form-select-option :value="null">{{ trans('Selectionnez une methode de calcul') }}
              </b-form-select-option>
              <b-form-select-option :key="'method_' + key" :value="method" v-for="(method, key) in methods">
                {{ trans(method.label) }}
              </b-form-select-option>
            </b-form-select>
          </div>


          <div class="col-12 m-2 flex-grow-1">
            <label :for="'label'" class="form-label">{{ trans("Branches concernées") }}</label>


            <div>
              <template v-for="(category, catIndex) in branchCategories">
                <div v-for="(branch, branchIndex) in category.branches"
                  :key="'gen_branch_' + catIndex + '_' + branchIndex" class="form-check form-check-inline">
                  <input class="form-check-input" v-model="params.branchs" type="checkbox" :id="'gen_' + branch.slug"
                    :value="branch.slug">
                  <label class="form-check-label" :for="'gen_' + branch.slug"> {{ category.label }} - {{
                    trans(branch.label)
                    }}</label>
                </div>
              </template>
            </div>




          </div>


          <div class="col-12 m-2 flex-grow-1">
            <label :for="'label'" class="required form-label">{{ trans("Assureur concerné") }}</label>


            <div>
              <div v-for="(insurer, insurerIndex) in insurers" :key="'gen_insurer_' + insurerIndex"
                class="form-check form-check-inline">
                <input class="form-check-input" v-model="params.insurers" type="checkbox" :id="'gen_' + insurer.slug"
                  :value="insurer.slug">
                <label class="form-check-label" :for="'gen_' + insurer.slug"> {{ trans(insurer.label) }}</label>
              </div>
            </div>
          </div>
















          <div class="col-auto m-2 flex-grow-1">
            <label class="form-label">{{ trans('Description') }}</label>
            <div>
              <textarea class="form-control" v-model="params.description"></textarea>
            </div>
          </div>


        </div>

      </form>
      <template #modal-footer="{ cancel, hide }">
        <b-button @click="cancel()" size="sm" variant="secondary">
          <i class="fad fa-times"></i>
          {{ trans('Cancel') }}
        </b-button>
        <b-button @click="generateVouchers(), hide()" size="sm" variant="primary">
          <i class="fad fa-save"></i>
          {{ trans('Generer') }}
        </b-button>
      </template>
    </b-modal>






  </template>
  </Base>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { api } from "@/services/Api";
import Base from "@/layouts/Base.vue";
import Popup from "@/entity/Popup";
import { helper } from '@/services/Helper';
import EngineMethod from '@/entity/EngineMethod';
import Voucher from '@/entity/Voucher';
import VoucherGroup from '@/entity/VoucherGroup';
import Partner from '@/entity/Partner';
import BranchCategory from '@/entity/BranchCategory';
import Insurer from '@/entity/Insurer';
import ItemType from '@/entity/ItemType';
import PackCategory from '@/entity/PackCategory';

@Component({
  components: { Base }
})
export default class VoucherManager extends Vue {

  engineVersion = null
  formats = []
  voucherEdit: Voucher = new Voucher()
  helper = helper
  groups: VoucherGroup[] = []
  methods: EngineMethod[] = []
  vouchers: Voucher[] = []
  voucher: Voucher = new Voucher()
  reducSelected = null
  params: any = {

    branchs: [],
    insurers: [],
    packs: [],

  }

  get editStartDate(): string {
    if (this.voucherEdit.startDate instanceof Date) {
      return this.voucherEdit.startDate.toISOString().split('T')[0]
    }
    return this.voucherEdit.startDate || ''
  }

  set editStartDate(value: string) {
    this.voucherEdit.startDate = value ? new Date(value) : undefined
  }

  get editEndDate(): string {
    if (this.voucherEdit.endDate instanceof Date) {
      return this.voucherEdit.endDate.toISOString().split('T')[0]
    }
    return this.voucherEdit.endDate || ''
  }

  set editEndDate(value: string) {
    this.voucherEdit.endDate = value ? new Date(value) : undefined
  }
  // resetDataType() {
  //   this.VoucherModel = new VoucherModel()
  // }



  async load() {
    const pop = new Popup('Chargement...', 'Chargement des coupons', 'primary', 'fad fa-sync', true)
    const res = await api.get(api.core, 'voucher/list')
    if (res && res.data && res.data.vouchers) {
      // (this.$refs.editVoucherModal as any).hide()
      this.vouchers = []
      res.data.vouchers.forEach((voucher: Voucher) => {
        this.vouchers.push(new Voucher(voucher))
      })
    }
    pop.hide()
  }

  async loadMethods() {
    // const method = { id: this.method.id, label: this.method.label, description: this.method.description }
    const pop = new Popup('Chargement des modeles', '', 'primary', 'fad fa-sync', true)
    let url = 'engine/method/list/global';

    const res = await api.get(api.core, url)

    if (res && res.data && res.data.globalMethods) {
      // console.log('res.data.methods', res)
      // this.methods = []
      // res.data.globalMethods.forEach((m: any) => {
      //   const occ = new EngineMethod(m)
      //   this.methods.push(occ)
      // })
      res.data.globalMethods.forEach((m: any) => {
        const occ = new EngineMethod(m)
        occ.label = 'GLOBAL ' + occ.label
        this.methods.push(occ)
      })
    }

    pop.hide()
  }


  async generateVouchers() {
    const pop = new Popup('Generation des coupons', '', 'primary', 'fad fa-sync', true)
    const res = await api.post(api.core, 'voucher/generate', this.params)
    if (res && res.data && res.data.type) {
      (this.$refs as any).dataTypeModal.hide()
    }

    pop.hide()
    this.load()
  }


  async editVoucher() {
    const pop = new Popup('Modification du coupon', '', 'primary', 'fad fa-sync', true)
    const res = await api.post(api.core, 'voucher/edit', this.voucherEdit)
    if (res && res.data && res.data.type) {
      (this.$refs as any).dataTypeModal.hide()
    }

    console.log(this.voucherEdit, 'voucherEdit')

    pop.hide()
    this.load()
  }



  // async loadGroups() {
  //   // const pop = new Popup('Chargement des groupes de ', '', 'primary', 'fad fa-sync', true)
  //   const res = await api.get(api.core, 'voucher/group/list')
  //   if (res && res.data && res.data.VoucherGroups) {
  //     // (this.$refs.editVoucherModal as any).hide()
  //     this.groups = []
  //     res.data.VoucherGroups.forEach((group: VoucherGroup) => {
  //       this.groups.push(new VoucherGroup(group))
  //     })

  //   }
  //   // pop.hide()
  // }


  insurers: Insurer[] = []
  branchCategories: BranchCategory[] = []
  packCategories: PackCategory[] = []

  async loadRequiremenent() {
    // const pop = new Popup('Chargement des groupes de ', '', 'primary', 'fad fa-sync', true)

    const res = await api.get(api.core, 'contract/list/requirements')
    if (res && res.data) {

      this.insurers = []
      res.data.insurers.forEach((i: Insurer) => {
        this.insurers.push(new Insurer(i))
      })
      this.branchCategories = []
      res.data.categories.forEach((i: Insurer) => {
        this.branchCategories.push(new BranchCategory(i))
      })

      this.packCategories = []
      res.data.packCategories.forEach((pc: PackCategory) => {
        this.packCategories.push(new PackCategory(pc))
      })

    }
    // pop.hide()
  }



  async mounted() {
    await this.load()
    // this.loadGroups()
    this.loadRequiremenent()
    this.loadMethods()
  }



  // async editMethod() {
  //   this.$store.commit('loading')
  //   const method = {id: this.method.id, label: this.method.label, description: this.method.description}
  //   let url = 'engine/method/edit';

  //   const res = await api.post(api.core, url, {method})
  //   if (this.$refs.methodModal) {
  //     (this.$refs.methodModal as any).hide()
  //   }
  //   this.$store.commit('stopLoading')
  //   this.loadGroups()
  //   this.loadMethods()
  // }

}
</script>
<style scoped></style>
